import { render, staticRenderFns } from "./QuotationStepInstallation.vue?vue&type=template&id=084c67bc&scoped=true"
import script from "./QuotationStepInstallation.vue?vue&type=script&lang=js"
export * from "./QuotationStepInstallation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c67bc",
  null
  
)

export default component.exports